import React from 'react';
import { AttributeType, Attribute } from 'common/constants/types';
import { Dayjs } from 'dayjs';
import { AddedSection, AddedAttributeType } from '../../types';
import AttributeTypeEditField from './AttributeTypeEditField/AttributeTypeEditField';
import styles from './SectionEditFields.module.scss';

interface Props {
  addedSections: AddedSection[];
  section: AddedSection;
  sections: AddedSection[];
  showAttributeEndTime: boolean;
  showAttributeStartTime: boolean;
  userAttributeTypes: AddedAttributeType[];
  getAttributes: (attributeTypeName: string) => Attribute[];
  getDateValue: (attributeTypeName: string) => Dayjs | undefined;
  getAddedAttributeValue: (sectionName: string, attributeTypeName: string) => string | undefined;
  renderUIDAttributeEditLink: (section: AddedSection, attributeType: AttributeType) => React.ReactElement;
  setUserAttributeTypes: (userAttributeTypes: AddedAttributeType[]) => void;
  setAddedSections: (addedSections: AddedSection[]) => void;
}

const SectionEditFields = ({
  addedSections,
  section,
  sections,
  showAttributeEndTime,
  showAttributeStartTime,
  userAttributeTypes,
  getAttributes,
  getDateValue,
  getAddedAttributeValue,
  renderUIDAttributeEditLink,
  setUserAttributeTypes,
  setAddedSections,
}: Props) => (
  <div className={styles.sectionEditFields}>
    <div className={styles.description}>
      {section.description}
    </div>
    <div className={styles.attributeTypeEditFieldWrapper}>
      {section.attribute_types.map(attributeType => (
        <div className={styles.attributeTypeEditField} id={attributeType.name} key={attributeType.name}>
          <div className={styles.description}>
            {attributeType.description}
          </div>
          <div className={styles.editFieldWrapper}>
            <AttributeTypeEditField
              addedSections={addedSections}
              attributeType={attributeType}
              getAddedAttributeValue={getAddedAttributeValue}
              getAttributes={getAttributes}
              getDateValue={getDateValue}
              key={attributeType.name}
              renderUIDAttributeEditLink={renderUIDAttributeEditLink}
              section={section}
              sections={sections}
              setAddedSections={setAddedSections}
              setUserAttributeTypes={setUserAttributeTypes}
              showAttributeEndTime={showAttributeEndTime}
              showAttributeStartTime={showAttributeStartTime}
              userAttributeTypes={userAttributeTypes}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SectionEditFields;
